interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SEOSchema({ type, data = {} }: SEOSchemaProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '虫虫动漫',
      url: 'https://chongchongmanhua.com',
      description: '虫虫动漫提供免费漫画与免费看漫画在线平台，海量免费动漫全集免费阅读，下拉式滚动浏览让您畅享免费漫画网站大全。',
      foundingDate: '2020',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '虫虫动漫',
      url: 'https://chongchongmanhua.com',
      potentialAction: {
        '@type': 'SearchAction',
        'target': {
          '@type': 'EntryPoint',
          urlTemplate: 'https://chongchongmanhua.com/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '虫虫动漫 - 免费漫画在线阅读',
      description: '虫虫动漫提供免费漫画与免费看漫画在线平台，海量免费动漫全集在线阅读。',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: (data.mainEntity as Record<string, string>[]) || [],
    },
  };

  const schema = schemas[type] || {};

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}